<template>
  <!-- 员工管理 -->
  <div class="wrapper">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-user title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-count">
          <span class="count-label">共</span>
          <span class="count-value">{{ total }}</span>
          <span class="count-label">条记录</span>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 左侧部门树 -->
      <el-card class="left-card" shadow="never">
        <div slot="header" class="card-header">
          <i class="el-icon-s-grid"></i>
          <span>部门选择</span>
        </div>
        <SelectDept v-model="searchData.deptId"></SelectDept>
        <div class="tree">
          <el-tree
              ref="tree"
              node-key="id"
              highlight-current
              :data="treeData"
              :props="defaultProps"
              :expand-on-click-node="false"
              :default-expand-all="true"
              @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </el-card>

      <!-- 右侧内容 -->
      <div class="right">
        <!-- 搜索区域 -->
        <el-card class="search-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-search"></i>
            <span>搜索条件</span>
          </div>
          <div class="header-search">
            <el-form ref="form" inline label-width="100px">
              <el-form-item label="员工姓名">
                <el-input style="width:250px" v-model="searchData.userName" size="small" placeholder="请输入员工姓名"></el-input>
              </el-form-item>

              <el-form-item label="手机号">
                <el-input style="width:250px" v-model="searchData.mobile" size="small" placeholder="请输入手机号"></el-input>
              </el-form-item>

              <el-form-item label=" ">
                <el-button type="primary" size="small" class="search-btn" @click="getAdminList">
                  <i class="el-icon-search"></i>
                  <span>搜索</span>
                </el-button>
                <el-button type="info" size="small" class="reset-btn" @click="reset">
                  <i class="el-icon-refresh-left"></i>
                  <span>重置</span>
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 表格区域 -->
        <el-card class="table-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-s-order"></i>
            <span>员工列表</span>
            <el-button
                v-checkbtn="isShowBtn(AUTH_BTN.user_list_add)"
                type="primary"
                size="small"
                class="add-btn"
                @click="showAddOrEdit = true;rowId = null;"
            >
              <i class="el-icon-plus" style="color: #fff;"></i>
              <span>新增</span>
            </el-button>
          </div>

          <tp-table
              :isNeedSerialNumber="false"
              :tableData="list"
              :columns="columns"
              :totalNum="total"
              :current-page.sync="currentPage"
              :pageSize.sync="pageSize"
          />
        </el-card>
      </div>
    </div>

    <!-- 新增&编辑 -->
    <AddOrEdit
        v-if="showAddOrEdit"
        :rowId="rowId"
        :showAddOrEdit="showAddOrEdit"
        @closeDialog="closeDialogFun"
    />
  </div>
</template>

<script>
import SelectDept from '@/views/components/select-dept.vue';
import { getAdminList, removeAdmin, getRoleList, changeStatus, getDeptTree } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import AddOrEdit from "./add-edit.vue";

const columns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '100',
    customRender(h, row) {
      return <div>{row['id']}</div>
    }
  },
  {
    label: '员工姓名',
    prop: 'userName',
    minWidth: '120',
    customRender(h, row) {
      return <div>{row['userName']}</div>
    }
  },
  {
    label: '手机号',
    minWidth: '150',
    prop: 'mobile',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['mobile']}>
            {row['mobile']}
          </p>
      )
    }
  },
  {
    label: '角色',
    width: '120',
    prop: 'roleName',
    customRender(h, row) {
      return <p class="one-line">{row['role']?.['roleName']}</p>
    }
  },
  {
    label: '部门',
    minWidth: '120',
    prop: 'dept',
    customRender(h, row) {
      return <div>{row['dept']?.['deptName']}</div>
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '120',
    customRender(h, row) {
      return (
          <div>
            <el-switch
                class="switch"
                onChange={() => this.changeStatus(row)}
                disabled={row['isSuper'] || !this.isShowBtn(this.AUTH_BTN.user_list_status)}
                v-model={row['status']}
                active-value={true}
                inactive-value={false}
                active-text="启用"
                inactive-text="禁用"
            ></el-switch>
          </div>
      )
    }
  },
  {
    label: '性别',
    minWidth: '80',
    prop: 'genderName',
    customRender(h, row) {
      return <div>{row['genderName']}</div>
    }
  },
  {
    label: '创建时间',
    minWidth: '180',
    prop: 'createTime',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['createTime']}>
            {row['createTime']}
          </p>
      )
    }
  },
  {
    label: '操作',
    fixed: 'right',
    minWidth: '120',
    customRender(h, row) {
      return (
          <div>
            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.user_list_edit)}
                disabled={row['isSuper'] == 1}
                underline={false}
                type="primary"
                onClick={() => {
                  this.showAddOrEdit = true;
                  this.rowId = row["id"];
                }}
            >
              编辑
            </el-link>

            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.user_list_del)}
                disabled={row['isSuper'] == 1}
                underline={false}
                style="margin:0 10px"
                type="danger"
                onClick={() => this.goRemove(row['id'])}
            >
              删除
            </el-link>
          </div>
      )
    }
  }
];

export default {
  name: 'SystemUserList',
  mixins: [authBtnMixin],
  components: { SelectDept, AddOrEdit },
  data() {
    return {
      dialogVisible: false,
      isShow: false,
      list: [],
      pageSize: 10,
      defaultProps: {
        children: 'children',
        label: 'deptName'
      },
      searchData: {
        userName: '',
        mobile: '',
        roleId: '',
        deptId: '',
        jobId: ''
      },
      total: 0,
      currentPage: 1,
      columns,
      roleList: [],
      treeData: [],
      currentDept: {}, //树形的每项数据
      rowId: null,
      showAddOrEdit: false,
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getAdminList();
    },
    pageSize() {
      this.getAdminList();
    },
    treeData: {
      handler() {
        if (this.treeData.length > 0 && !this.currentDept.id) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].id);
            this.currentDept = this.$refs.tree.getCurrentNode();
            this.getAdminList();
          })
        }
      }
    },
    'searchData.deptId': {
      handler(newV, oldV) {
        this.$refs.tree.setCurrentKey(newV);
        this.getAdminList();
      }
    }
  },

  mounted() {
    this.getRoleList();
    this.getDeptTree();
  },

  methods: {
    async getRoleList() {
      let params = { page: 1, pageSize: 50 };
      const res = await getRoleList(params);
      this.roleList = res.list || [];
    },
    async getAdminList() {
      const { userName, mobile, roleId, jobId } = this.searchData;
      const { id } = this.currentDept;
      let params = { userName, mobile, roleId, deptId: id, jobId, page: this.currentPage, pageSize: this.pageSize };
      let res = await getAdminList(params);
      this.list = res?.list || [];
      this.total = res?.total || 0;
    },
    async goRemove(id) {
      this.$confirm('确定要删除该员工吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            removeAdmin({ id }).then(() => {
              this.$message.success('删除成功');
              this.getAdminList();
            })
          })
          .catch(() => {})
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getAdminList();
    },
    changeStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let statusDesc = status ? '启用' : '禁用';

      this.$confirm(`确定要${statusDesc}该员工吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            row.status = status;
            changeStatus(data).then(() => {
              this.getAdminList();
              this.$message.success('操作成功');
            })
          })
          .catch(() => {
            row.status = !status;
          })
    },
    async getDeptTree() {
      const res = await getDeptTree();
      this.treeData = res || [];
      this.$nextTick(() => {
        this.currentDept = this.$refs.tree.getCurrentNode();
      })
    },
    handleNodeClick(data, node) {
      this.currentDept = data;
      this.getAdminList();
    },
    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      if (flag) {
        this.getAdminList();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 28px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    
    .count-label {
      color: #909399;
    }
    
    .count-value {
      color: #409EFF;
      font-weight: 600;
      font-size: 18px;
    }
  }
}

.container {
  display: flex;
  gap: 20px;
  position: relative;
  z-index: 1;
  
  .left-card {
    width: 280px;
    flex-shrink: 0;
    border-radius: 16px;
    border: none;
    background: #ffffff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
    }
    
    &:hover {
      box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
      transform: translateY(-2px);
    }
    
    .card-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      
      i {
        font-size: 18px;
        color: #409EFF;
      }
    }
    
    ::v-deep .el-card__body {
      padding: 20px;
    }
    
    .el-cascader {
      width: 100%;
      margin-bottom: 16px;
      
      ::v-deep .el-input__inner {
        border-radius: 10px;
        border: 1.5px solid #E4E7ED;
        transition: all 0.3s ease;
        
        &:hover {
          border-color: #C0C4CC;
        }
        
        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
        }
      }
    }
    
    .tree {
      .el-tree ::v-deep {
        .el-tree-node__content {
          height: 40px;
          border-radius: 8px;
          margin-bottom: 4px;
          transition: all 0.3s ease;
          
          &:hover {
            background: rgba(64, 158, 255, 0.08);
          }
          
          .el-tree-node__expand-icon {
            margin-left: 20px;
            color: #909399;
          }
        }
        
        .el-tree-node.is-current > .el-tree-node__content {
          background: linear-gradient(90deg, rgba(64, 158, 255, 0.15) 0%, rgba(102, 177, 255, 0.08) 100%);
          border-right: 3px solid #409EFF;
          
          .el-tree-node__label,
          .el-tree-node__expand-icon {
            color: #409EFF;
            font-weight: 600;
          }
          
          .el-tree-node__expand-icon.is-leaf {
            color: transparent !important;
          }
        }
      }
    }
  }
  
  .right {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}

// 搜索卡片样式
.search-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  .card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    
    i {
      font-size: 18px;
    }
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        
        .el-form-item__label {
          color: #303133;
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 14px;
          position: relative;
          
          &::after {
            content: ':';
            margin-left: 2px;
            color: #909399;
          }
        }
        
        .el-input {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            line-height: 38px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafbfc;
            font-size: 13px;

            &:hover {
              border-color: #C0C4CC;
              background: #ffffff;
            }
          }
          
          &.is-active .el-input__inner,
          .el-input__inner:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
      }
      
      .search-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;
        display: inline-flex;
        align-items: center;
        gap: 6px;

        &:hover:not(.is-disabled) {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }

      .reset-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;
        display: inline-flex;
        align-items: center;
        gap: 6px;

        &:hover {
          background: linear-gradient(135deg, #909399 0%, #82848a 100%);
          box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
        }
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    
    i {
      font-size: 18px;
      color: #409EFF;
      margin-right: 8px;
    }
    
    .add-btn {
      border-radius: 10px;
      padding: 8px 20px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: 0.3px;
      display: inline-flex;
      align-items: center;
      gap: 6px;

      &:hover:not(.is-disabled) {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      }
    }
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }
  
  // switch按钮样式
  ::v-deep .switch {
    .el-switch__label {
      position: absolute;
      display: none;
      color: #fff !important;
    }
    
    .el-switch__label--right {
      z-index: 1;
      span {
        margin-left: 5px;
      }
    }
    
    .el-switch__label--left {
      z-index: 1;
      span {
        margin-left: 20px;
      }
    }
    
    .el-switch__label.is-active {
      display: block;
    }
    
    .el-switch__core,
    .el-switch__label {
      width: 55px !important;
      margin: 0;
    }
  }
  
  // 操作链接样式
  ::v-deep .el-link {
    transition: all 0.3s ease;
    
    &:hover {
      opacity: 0.8;
      transform: translateY(-1px);
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .wrapper {
    padding: 16px;
  }
  
  .container {
    gap: 16px;
    
    .left-card {
      width: 240px;
    }
  }
}

@media (max-width: 1200px) {
  .container {
    flex-direction: column;
    
    .left-card {
      width: 100%;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .container {
    gap: 12px;
  }
  
  .search-card,
  .table-card,
  .left-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
}
</style>
